<div class="create-rules" (click)="step === 1 && closeCoinSelector()">
  <div class="create-rules__back-button" [routerLink]="'/dca'" routerLinkActive="active">
    <img src="/assets/icons/dca/arrow-back.svg" alt="back" />
    Volver
  </div>
  <div class="create-rules__container">
    <app-step-one
      [srcCoinSelectorOpened]="srcCoinSelectorOpened"
      [destCoinSelectorOpened]="destCoinSelectorOpened"
      [recoveryData]="data"
      (openSelectSrcCoin)="srcCoinSelectorOpened = $event"
      (openSelectDestCoin)="destCoinSelectorOpened = $event"
      (nextStep)="step = $event"
      (data)="setData($event)"
      *ngIf="step === 1"
    ></app-step-one>
    <app-step-two [data]="data" (backStep)="step = $event" *ngIf="step === 2"></app-step-two>
  </div>
</div>
